import { useState } from 'react'
import Logo from './Logo'
import { MenuIcon } from './ui'
import { usePortalAuth } from '../auth/authContexts'
import { isDevMode } from '../utils/devMode'

const navLinks = [
  { label: '4X4', active: false },
  { label: 'Caravan', active: false },
  { label: 'Camper Trailer', active: false },
  { label: 'The Campfire', active: false },
  { label: 'Manage Policy', active: true },
  { label: 'Update Payment', active: false },
]

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { loginWithRedirect } = usePortalAuth()

  const handleSignIn = async () => {
    if (isDevMode()) {
      window.location.assign('/dashboard')
      return
    }
    try {
      await loginWithRedirect()
    } catch (error) {
      console.error('Error during sign in:', error)
    }
  }

  return (
    <nav className="bg-background-brand-solid h-20 relative w-full">
      <div className="absolute flex flex-col h-20 items-center justify-center left-0 right-0 top-0">
        <div className="flex gap-[16px] items-center max-w-container-desktop px-[16px] md:px-[32px] py-0 relative w-full">
          {/* Mobile: Logo and hamburger */}
          <div className="flex md:hidden gap-[12px] items-center relative w-full">
            <Logo />
            <span className="font-body text-xs text-text-primary-on-brand/80 uppercase tracking-wider">
              Development version
            </span>
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="ml-auto cursor-pointer flex items-center justify-center overflow-clip p-[8px] relative rounded-md shrink-0"
              aria-label="Toggle menu"
            >
              <MenuIcon />
            </button>
          </div>

          {/* Desktop: Full navigation */}
          <div className="hidden md:flex gap-[20px] items-center relative w-full">
            <div className="flex gap-[12px] items-center relative shrink-0">
              <Logo />
            </div>
            <div className="flex flex-1 gap-[2px] items-center justify-center min-h-px min-w-px relative shrink-0">
              {navLinks.map((link) => (
                <button
                  key={link.label}
                  className={`flex gap-[2px] items-center justify-center overflow-clip px-[6px] py-[4px] relative rounded-md ${
                    link.active
                      ? 'text-foreground-brand-primary-alt'
                      : 'text-text-primary-on-brand'
                  }`}
                >
                  <span className="font-display font-semibold text-md">
                    {link.label}
                  </span>
                </button>
              ))}
            </div>
            <div className="flex gap-[12px] items-center relative shrink-0">
              <span className="font-body text-xs text-text-primary-on-brand/80 uppercase tracking-wider">
                Development version
              </span>
              <button
                onClick={handleSignIn}
                className="bg-background-primary border border-border-primary border-solid flex gap-[6px] items-center justify-center overflow-clip px-[16px] py-[10px] relative rounded-md shadow-xs shrink-0 cursor-pointer"
              >
                <span className="font-body font-semibold text-md text-text-secondary-700">
                  Sign in
                </span>
                              </button>
              <a
                href="#quote"
                className="bg-foreground-brand-primary-alt flex gap-[6px] items-center justify-center overflow-clip px-[16px] py-[10px] relative rounded-md shadow-xs shrink-0"
              >
                <span className="font-body font-semibold text-md text-text-secondary-700">
                  Get a quote
                </span>
                              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile menu dropdown */}
      {isMenuOpen && (
        <div className="absolute top-20 left-0 right-0 bg-background-brand-solid border-t border-brand-border p-4 md:hidden z-50">
          <div className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <button
                key={link.label}
                className={`text-left px-4 py-2 rounded-md ${
                  link.active
                    ? 'text-foreground-brand-primary-alt bg-white/10'
                    : 'text-text-primary-on-brand'
                }`}
              >
                <span className="font-body font-semibold text-md">
                  {link.label}
                </span>
              </button>
            ))}
            <div className="flex flex-col gap-2 pt-4 border-t border-brand-border">
              <button
                onClick={handleSignIn}
                className="bg-background-primary border border-border-primary border-solid flex items-center justify-center px-4 py-3 rounded-md shadow-xs cursor-pointer"
              >
                <span className="font-body font-semibold text-md text-text-secondary-700">
                  Sign in
                </span>
              </button>
              <a
                href="#quote"
                className="bg-foreground-brand-primary-alt flex items-center justify-center px-4 py-3 rounded-md shadow-xs"
              >
                <span className="font-body font-semibold text-md text-text-secondary-700">
                  Get a quote
                </span>
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  )
}
